export const useDefaultData = () => {

    const defaultDataModal = {
        open: false,
        titleModal: '',
        componentModal: '',
        dataRequest: {},
    }

    const defaultFormScreen = {
        idprocesstype: '',
        name_process: '',
        category: '',
        type: ''
    }

    return Object.freeze({
        defaultDataModal,
        defaultFormScreen
    })
}